import { section as sectionData } from "~/data";

export const AllSectionsOption: {
  text: string;
  value: string;
} = {
  text: "All",
  value: "",
};

export const SectionOptions: {
  text: string;
  value: string;
}[] = [
  { ...AllSectionsOption },
  {
    text: sectionData.hongKong.name,
    value: sectionData.hongKong.entityId,
  },
  {
    text: sectionData.china.name,
    value: sectionData.china.entityId,
  },
  {
    text: sectionData.asia.name,
    value: sectionData.asia.entityId,
  },
  {
    text: sectionData.world.name,
    value: sectionData.world.entityId,
  },
  {
    text: sectionData.business.name,
    value: sectionData.business.entityId,
  },
  {
    text: sectionData.peopleCulture.name,
    value: sectionData.peopleCulture.entityId,
  },
  {
    text: sectionData.sport.name,
    value: sectionData.sport.entityId,
  },
  {
    text: sectionData.comment.name,
    value: sectionData.comment.entityId,
  },
  {
    text: sectionData.lifestyle.name,
    value: sectionData.lifestyle.entityId,
  },
  {
    text: sectionData.thisWeekInAsia.name,
    value: sectionData.thisWeekInAsia.entityId,
  },
  {
    text: sectionData.postMagazine.name,
    value: sectionData.postMagazine.entityId,
  },
  {
    text: sectionData.abacus.name,
    value: sectionData.abacus.entityId,
  },
];
